<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">{{this.$route.meta.breadcrumb}}</h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <!-- Begin:ชื่องบประมาณ  -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ประเภทการตั้งค่าข้อมูลวัน Alert PM :</label>
                <select2
                    :id="'reAlertConfigType'"
                    :name="'reAlertConfigType'"
                    v-model="reAlertConfigType" 
                    :select2-options="reAlertConfigTypeOptions"
                    placeholder="กรุณาเลือก"
                  />
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"  v-if="reAlertConfigType=='AGENT' || reAlertConfigType=='SHOP'">
                <div class="form-group">
                  <label class="label-required">ตัวแทนจำหน่าย:</label>   
                  <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'apmrAgentCode'"
                  :name="'apmrAgentCode'"
                  :select2-options="apmrAgentCodeOptions"
                  v-model="apmrAgentCode"
                  ref="apmrAgentCodeSelect2"
                  @selectChange="AgentClearAfterselect"
                ></select2>

                </div>
              </div> 
              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"  v-if="reAlertConfigType=='SHOP'">
                <div class="form-group">
                  <label>ร้านค้าตัวแทนจำหน่าย</label>
                  <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'apmrShopCodes'"
                  :name="'apmrShopCodes'"
                  :select2-options="apmrShopCodesOptions"
                  @selectChange="ShopClearAfterselect" 
                  v-model="apmrShopCodes"
                  ref="apmrShopCodesSelect2" 
                ></select2>
                   
                </div>
              </div> 

               <!-------ตัวแทนย่อย---->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"  v-if="reAlertConfigType=='SHOP'">
                <div class="form-group">
                  <label>ตัวแทนจำหน่ายย่อย:</label>
                  
                  <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'apmrSubAgentCode'"
                  :name="'apmrSubAgentCode'"
                  :select2-options="apmrSubAgentCodeOptions"
                  v-model="apmrSubAgentCode"
                  ref="apmrSubAgentCodeSelect2"
                  @selectChange="SubAgentClearAfterselect" 
                ></select2>

                
                <!-- @selectChange="onApmrSubAgentCodeChange" -->
 
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"  v-if="reAlertConfigType=='SHOP'">
                <div class="form-group">
                  <label>ร้านค้าตัวแทนจำหน่ายย่อย:</label>
                  <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'apmrSubShopCodes'"
                  :name="'apmrSubShopCodes'"
                  :select2-options="apmrSubShopCodesOptions"
                  v-model="apmrSubShopCodes"
                  ref="apmrSubShopCodesSelect2"
                   
                ></select2>
                   
                </div>
              </div>
            <!-------สิ้นสุดตัวแทนย่อย-->

          </div>
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"  >
                <div class="form-group">
                  <label class="label-required">แบรนด์สินค้า:</label>
                  <div style="font-size: 80%; color: #fd397a;" v-if="reqBrand">{{ reqBrandMsg }}</div>
                </div>
              </div>
          </div>
          <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table
                    class="table table-sm table-striped table-bordered table-hover table-checkable"
                    style="min-width: 1440px;"
                  >
                    <thead>
                      <tr>
                        <th class="text-center" width="5%">ลำดับ</th>
                        <th class="text-center" width="15%">แบรนด์</th>
                        <th class="text-center" width="15%">จำนวนวัน</th>
                        <th class="text-center" width="15%">ไฟล์อัพโหลด</th>
                        <th class="text-center" >ชื่อไฟล์</th> 
                        <!--th class="text-center" width="5%">คำสั่ง</th-->
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="brandsitems == null || brandsitems.length == 0">
                        <td colspan="9" class="text-muted text-center">
                          คลิก + เพื่อเพิ่มรายการใหม่
                        </td>
                      </tr>
                      <template v-for="(item, i) in brandsitems">
                        <item-rows
                          ref="brandItems" 
                          :rowIndex="i"
                          :item="item"
                          @removeItem="onRemoveItemClick"
                        ></item-rows>
                      </template>
                    </tbody>
                    <!-- <tfoot>
                      <tr>
                        <td colspan="9">
                          <button
                            type="button"
                            class="btn btn-sm btn-brand"
                            @click.prevent="onAddItemClick"
                          >
                            <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                          </button>
                        </td>
                      </tr>
                    </tfoot> -->
                  </table>

                  <button
                    type="button" style="visibility: hidden;"
                    id="btnupload"
                    class="btn m-btn--pill btn-info btn-block uploader-btn col-xl-2"
                    @click="uploadFile"
                  >
                    <i class="flaticon-upload-1"></i>ไฟล์
                  </button>
                <div class="row" id="container-file"></div>

                </div>
              </div>
        </div>
      </div>

      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary" data-dismiss="modal">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
 
import Vue from "vue";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
import itemRows from "./ItemRow";
import plupload from "plupload";
import axios from "axios";
 

export default {
  components: {
    select2, 
    itemRows,
  },
  data() {
    var self = this;
    return {
      uuid: null, 
      current_upload_row : null ,

      reqBrand : false ,
      reqBrandMsg : "กรุณาเลือกแบรนด์สินค้า",

      brandsitems: [],
 
      apmrAgentCode: null,
      apmrSubAgentCode : null,
      apmrShopCodes: null,
      apmrSubShopCodes : null,

      reAlertConfigType : "SHOP",
      reAlertConfigTypeOptions :[],
 
      reAlertConfigTypeOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "AGENT", text: "ประเภทตัวแทนจำหน่าย", data: null },
          { id: "SHOP", text: "ประเภทร้านค้า", data: null }, 
        ],
      },
      pmrAgentCodesOptions:[], 
      pmrShopCodesOptions : [],
      
      apmrAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย"  ,
        allowClear: true,
        multiple : false,
        ajax: {
          url: self.$root.canShow(["AGENT_ADMIN_PM"]) ? "/Api/Agents/AgentOptions" : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              agentCodes: [],
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      apmrShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        multiple : false,
        ajax: {
          url: "/Api/Shop/Select2ShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },  
      apmrSubShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        multiple : false,
        ajax: {
          url: "/Api/Shop/SubShopOptionAlertReport",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
 
            var query = { 
              agentCodes : self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
              shopCodes  : self.apmrSubAgentCode != null ? [self.apmrSubAgentCode] : null,
              search: params.term,
              page: params.page || 1,
              all: true,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 
      apmrSubAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        multiple : false,
        ajax: {
          url: "/Api/Report/Select2SubShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes:  self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
              shopCodes :  self.apmrAgentCode != null ? [self.apmrShopCodes] : null,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },  
       
    };
  },
  computed: {
    BcBalanceCal() {
      this.bcBalance =
        this.bcUsed != null ? this.bcBudget - this.bcUsed : this.bcBudget;
      return this.bcBalance;
    }
  },
  methods: {
      formSubmit: function(e) {
        let router = this.$router;
        let self = this;

        if(self.brandsitems == undefined || self.brandsitems == null || self.brandsitems.length <= 0){
          self.reqBrand = true ; 
        }
        else{
          self.reqBrand = false ;
        }

        if ( !$(this.$refs.form).validate().form() || self.reqBrand) {
          return false;
        }
 

        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
        });

        axios
          .post("/Api/MasterOverdueSetting/SaveAlertPMConfig", { 
           AlertConfigType : self.reAlertConfigType ,
           AgentCodes : self.apmrAgentCode ,
           ShopCodes : self.apmrShopCodes ,
           SubAgentCodes : self.apmrSubAgentCode ,
           SubAgentShopCodes : self.apmrSubShopCodes ,
           Brands : self.brandsitems 
          })
          .then(function(response) {
            if (response.data.status) {
              KTApp.unblockPage();
              Swal.fire("สำเร็จ", response.data.message, "success").then(
                function() {
                  router.go(-1), self.$parent.reloadDataTable(false);
                }
              );
            } else {
              //console.log(response);
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          })
          .catch(function(error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          })
          .then(function() {
            // always executed
            KTApp.unblockPage();
          });
      },  
      doUploadClick(row){ 
        let self = this; 
        self.current_upload_row = row ;
        $("#btnupload").click();
      }, 
      GetDownloadFile(fileDownload){
        let self = this; 
        let fileUrl = fileDownload.fileInfoId
          axios
            .get("/Api/File/FileDownload", {
              params: {
                FileInfoId: fileUrl
              }
            })
            .then(function(response) { 
                self.current_upload_row.DownloadFileUrl = response.data.fileUrl;  
            })
            .catch(error => {
              
            });
        
      },
      uploadFile() {
      let self = this; 
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg,application/msword,application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.presentationml.presentation";
      input.click();

      input.addEventListener("change", (event) => {
        const files = event.target.files;
        Array.from(files).forEach((file) => {
          if (
            ["image/jpeg", "image/jpg", "image/png","application/msword","application/vnd.ms-excel","application/vnd.ms-powerpoint","text/plain","application/pdf","application/vnd.openxmlformats-officedocument.presentationml.presentation","application/vnd.openxmlformats-officedocument.spreadsheetml.sheet","application/vnd.openxmlformats-officedocument.wordprocessingml.document"].includes(file.type) &&
            file.size <= 100 * 1024 * 1024
          ) 
          {
            const reader = new FileReader();

            var _BucketName = "MasterAlertPM";
              self.current_upload_row.FileName = file.name ;  
              try {
                var isUploadFile = true;
                const formData = new FormData();
                formData.append("File", file);
                formData.append("IsMaster", true);
                formData.append("FolderName", _BucketName);

                const uploadResponse =   axios.post("/Api/File/FileUpload", formData, {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                }).then(
                  function (response) {   
                    self.current_upload_row.DownloadUrl= response.data.fileUrl;
                    self.current_upload_row.FileInfoId= response.data.fileInfoId;
                    self.current_upload_row.FileName= file.name;
                    self.current_upload_row.GridFsId= response.data.gridFsId;
                    self.current_upload_row.SysName="-" ; 
                    self.current_upload_row.BucketName = _BucketName ;
                    self.GetDownloadFile(response.data) ; 
                  });  

            } catch (error) {
              console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", error);
            } 
          } else {
            alert(
              "กรุณาเลือกไฟล์ที่ถูกต้อง (ขนาดไม่เกิน 100MB)"
            );
          }
        });
      });
    },
    onAddItemClick(e) {
      this.brandsitems.push({
        Brandid: null,
        BrandName: null,
        Days: 15,
        FileUpload: null, 
        ContentType: null,
        DownloadUrl: null,
        FileInfoId: null,
        FileName: null,
        GridFsId: null,
        SysName: null, 
        DownloadFileUrl: null,
        BucketName : null
      });
    },
    onRemoveItemClick(index, delItem) {
      this.brandsitems.splice(index, 1);
      for (let i = 0; i < this.brandsitems.length; i++) {}
    },
    onApmrAgentTypeCodeChange : function(obj){
     
     var self = this; 
     
     this.apmrAgentCode = null; 
     $("#apmrAgentCode")
     .val("")
     .trigger("change"); 

     this.apmrShopCodes = null;  
     $("#apmrShopCodes")
       .val("")
       .trigger("change");  


     this.apmrSubAgentCode = null ; 
     $("#apmrSubAgentCode")
     .val("")
     .trigger("change");

     this.apmrSubShopCodes = null; 
     $("#apmrSubShopCodes")
     .val("")
     .trigger("change");

      
       
   },
   onApmrAgentCodeChange() {

     this.apmrShopCodes = null;  
     $("#apmrShopCodes")
       .val("")
       .trigger("change"); 

     this.apmrPmUserId = null; 
     $("#apmrPmUserId")
       .val("")
       .trigger("change");
 

    
   },
   onApmrSubAgentCodeChange: function(id, text, data, ref) { 

     var self = this;  
     if(data[0]!=undefined){ 
       this.apmrAgentCode = data[0].data ;
     }  

     this.apmrPmUserId = null; 
     $("#apmrPmUserId")
       .val("")
       .trigger("change"); 

       this.apmrSubShopCodes = null; 
     $("#apmrSubShopCodes")
     .val("")
     .trigger("change");
    },
    GetBrands(){
       
        let self = this;  
          axios
            .get("/Api/Report/PM/ProductBrandOptions", {
              params: {
                search: null,
                page:  1
              }
            })
            .then(function(response) {   
                $.each( response.data.results, function( key, value ) {
                  self.brandsitems.push({
                    Brandid: value.data,
                    BrandName: value.text,
                    Days: 15,
                    FileUpload: null, 
                    ContentType: null,
                    DownloadUrl: null,
                    FileInfoId: null,
                    FileName: null,
                    GridFsId: null,
                    SysName: null, 
                    DownloadFileUrl: null,
                    BucketName : null
                  });
                });
            })
            .catch(error => {
              
            }); 
        
      },
      AgentClearAfterselect: function(){  
      let self = this;
 
      self.apmrShopCodes = null;  
      self.apmrSubAgentCode = null; 
      self.apmrSubShopCodes = null; 

      $("#apmrShopCodes").val("").trigger("change");
      $("#apmrSubAgentCode").val("").trigger("change");
      $("#apmrSubShopCodes").val("").trigger("change");  
      $(`[class="vue-treeselect__input"]`).val("");

    },
    SubAgentClearAfterselect: function(){  
      let self = this;  
      self.apmrSubShopCodes = null; 
   
      $("#apmrSubShopCodes").val("").trigger("change");  
      $(`[class="vue-treeselect__input"]`).val("");

    },
    ShopClearAfterselect: function(){  
      let self = this;  

     
       
      self.apmrSubAgentCode = null; 
      self.apmrSubShopCodes = null; 
  
      $("#apmrSubAgentCode").val("").trigger("change");
      $("#apmrSubShopCodes").val("").trigger("change");  
      $(`[class="vue-treeselect__input"]`).val("");

    },
    
    ClearAfterselect: function(){ 
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this; 

    self.GetBrands();
 
    //set Current Year
    this.bcYear = new Date();
    $(this.$refs.form).validate({
      rules: {
        apmrAgentCode: "required",
        reAlertConfigType: "required" ,

      },
      messages: {
        apmrAgentCode: "กรุณาระบุตัวแทนจำหน่อย",
        reAlertConfigType: "กรุณาระบุประเภทการตั้งค่าข้อมูลวัน Alert PM" 
      }
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  }
};
</script>
 


// WEBPACK FOOTER //
// App/Components/Master/AlertPMConfig/Create.vue